import React from 'react';
import { TelemetryWorkspaceConfig } from '../types/telemetry-dashboard.types';
import '../styles/telemetry-dashboard-toolbar.css';

export interface TelemetryDashboardToolbarProps {
  workspaces?: TelemetryWorkspaceConfig[];
  activeWorkspaceId?: string | null;
  onSwitchWorkspace?: (id: string) => void;
  onAddWorkspace?: () => void;
  timeframe?: number;
  onTimeframeChange?: (t: number) => void;
  showWorkspaceTabs?: boolean;
  showTimeframeSelector?: boolean;
  showSettingsButton?: boolean;
  onOpenSettings?: () => void;
  actions?: React.ReactNode; // Slot for feature-specific custom buttons
}

export const TelemetryDashboardToolbar: React.FC<TelemetryDashboardToolbarProps> = ({
  workspaces = [],
  activeWorkspaceId,
  onSwitchWorkspace,
  onAddWorkspace,
  timeframe = 5,
  onTimeframeChange,
  showWorkspaceTabs = true,
  showTimeframeSelector = true,
  showSettingsButton = true,
  onOpenSettings,
  actions,
}) => {
  const timeframes = [1, 5, 15, 30, 60];

  return (
    <div id="telemetry-dashboard-toolbar" className="telemetry-dashboard-toolbar">
      {/* Workspace Tabs Section */}
      {showWorkspaceTabs && (
        <div id="telemetry-toolbar-tabs" className="telemetry-toolbar-tabs">
          {workspaces.map((ws) => {
            const isActive = ws.id === activeWorkspaceId;
            return (
              <button
                key={ws.id}
                id={`telemetry-toolbar-tab-${ws.id}`}
                className={`telemetry-toolbar-tab ${isActive ? 'telemetry-toolbar-tab--active' : ''}`}
                onClick={() => onSwitchWorkspace && onSwitchWorkspace(ws.id)}
              >
                <span>{ws.name}</span>
              </button>
            );
          })}

          {onAddWorkspace && (
            <button id="telemetry-toolbar-add-workspace-btn" className="telemetry-toolbar-add-tab-btn" onClick={onAddWorkspace} title="Add Workspace">
              +
            </button>
          )}
        </div>
      )}

      <span className="telemetry-toolbar-spacer" />

      {/* Timeframe Selector Section */}
      {showTimeframeSelector && onTimeframeChange && (
        <div id="telemetry-toolbar-timeframe-wrap" className="telemetry-toolbar-timeframe-wrap">
          {timeframes.map((tf) => (
            <button
              key={tf}
              id={`telemetry-toolbar-timeframe-${tf}m`}
              className={`telemetry-toolbar-tf-btn ${timeframe === tf ? 'telemetry-toolbar-tf-btn--active' : ''}`}
              onClick={() => onTimeframeChange(tf)}
            >
              {tf}m
            </button>
          ))}
        </div>
      )}

      {/* Settings Button */}
      {showSettingsButton && onOpenSettings && (
        <button id="telemetry-toolbar-settings-btn" className="telemetry-toolbar-icon-btn" onClick={onOpenSettings} title="Settings">
          ⚙
        </button>
      )}

      {/* Feature Custom Action Slot */}
      {actions && <div id="telemetry-toolbar-actions-slot" className="telemetry-toolbar-actions-slot">{actions}</div>}
    </div>
  );
};
